import { configureStore } from '@reduxjs/toolkit';
 
import adminAuthReducer from './slices/adminAuthSlice';
import customerAuthReducer from './slices/customerAuthSlice';

// Import the global loading slice
import loadingReducer from './loadingSlice';

import appOptionsReducer from './slices/optionsSlice';

// Import the training program slice
import trainingProgramReducer from './slices/admin/trainingSlice';
import adminExercisesReducer from './slices/admin/exerciseSlice';
import adminCategoriesReducer from './slices/admin/exerciseCategorySlice';

// Nutritions
import adminMealsReducer from './slices/admin/mealsSlice';
import adminRecipesReducer from './slices/admin/recipesSlice';
import adminIngredientsReducer from './slices/admin/ingredientsSlice';
import adminTypesReducer from './slices/admin/typesSlice';
import adminUnitsReducer from './slices/admin/unitsSlice';

//Users
import adminClientsReducer from './slices/admin/clientsSlice';
import adminUnassignedClientsReducer from './slices/admin/unassignedSlice';
import adminCoachesReducer from './slices/admin/coachesSlice';
import adminDeletedUsersSlice from './slices/admin/recycleBinSlice';
import adminDashboardReducer from './slices/admin/dashboardSlice';

import adminVideoReducer from './slices/admin/videoSlice';
import adminDragReducer from './slices/admin/dragSlice';

import adminPolicyPagesReducer from './slices/admin/privacyPolicyTermsSlice';
import adminPaymentsReducer from './slices/admin/paymentsSlice';
import adminEnquiriesReducer from './slices/admin/enquiriesSlice';

import weightTrackerReducer from './slices/customer/weightTrackerSlice';
import stepTrackerReducer from './slices/customer/stepTrackerSlice';
import mealPlanReducer from './slices/customer/mealPlanSlice';
import recipeReducer from './slices/customer/recipeSlice';
import videoReducer from './slices/customer/videoSlice';

import customerTrainingReducer from './slices/customer/trainingSlice';

import configurationReducer from './slices/customer/configurationSlice';
import customerPaymentsReducer from './slices/customer/paymentsSlice';
import customerRefersReducer from './slices/customer/inviteSlice';

import protectReducer from './slices/protectSlice';

import apiResponsesReducer from './apiSlice';

// Configure the Redux store
const store = configureStore({
  reducer: {
    apiResponses:apiResponsesReducer,
    adminAuth: adminAuthReducer,
    loading: loadingReducer,
    trainingPrograms: trainingProgramReducer,
    exercises: adminExercisesReducer,
    exerciseCategories:adminCategoriesReducer,
    admin_clients:adminClientsReducer,
    admin_unassigned_clients:adminUnassignedClientsReducer,
    admin_deleted_users:adminDeletedUsersSlice,
    admin_coaches:adminCoachesReducer,
    admin_units:adminUnitsReducer,
    admin_meals:adminMealsReducer,
    admin_recipes:adminRecipesReducer,
    admin_types:adminTypesReducer,
    admin_ingredients:adminIngredientsReducer,
    admin_dashboard:adminDashboardReducer,
    admin_videos:adminVideoReducer,
    app_options:appOptionsReducer,
    weightTracker:weightTrackerReducer,
    stepTracker:stepTrackerReducer,
    mealPlan:mealPlanReducer,
    recipes:recipeReducer,
    customer_videos:videoReducer,
    customer_training:customerTrainingReducer,
    customer_auth: customerAuthReducer,
    configuration:configurationReducer,
    protect:protectReducer,
    drag:adminDragReducer,
    policy:adminPolicyPagesReducer,
    customer_payments:customerPaymentsReducer,
    admin_payments:adminPaymentsReducer,
    admin_enquiries:adminEnquiriesReducer,
    customer_refers:customerRefersReducer
  },
});

// Export the configured store
export default store;